module.exports = __webpack_public_path__ + "img/mobilepay.2bbb41a2.png";